import { makeStyles } from '@material-ui/core/styles'

// Any time that we would like to add CSS to our Components we will create a styles object. The syntax is different then normal CSS. Please notice that camel case is used to set the list-style-type. For your reference please visit https://v4.mui.com
export const parkingButtonPanelStyles = makeStyles((theme) => ({
  parkingButtonPanelContainer: {
    position: 'absolute',
    top: '55px',
    left: '25px',
    width: 40,
    height: 'auto',
    display: 'flex',
    padding: 3,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  parkingButtonPanelContainerMobile: {
    position: 'absolute',
    top: '160px',
    left: '25px',
    width: 40,
    height: 'auto',
    display: 'flex',
    padding: 3,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  enabledButton: {
    color: theme.palette.backgroundColor.main,
    padding: 1,
    background: theme.palette.components.parkingLotIcons,
    borderRadius: '0.5rem',
    marginBottom: 3,
    '&:hover': {
      background: theme.palette.components.parkingLotIcons,
    },
  },
  disabledButton: {
    color: theme.palette.backgroundColor.main,
    opacity: 0.3,
    padding: 1,
    background: theme.palette.components.parkingLotIcons,
    borderRadius: '0.5rem',
    marginBottom: 3,
    '&:hover': {
      background: theme.palette.components.parkingLotIcons,
    },
  },
  busStopsButton: {
    color: theme.palette.backgroundColor.main,
    background: theme.palette.base.rutgersRed,
    '&:hover': {
      background: theme.palette.base.rutgersRed,
    },
  },
}))

export default parkingButtonPanelStyles
